/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { PagedListMetaData } from './pagedListMetaData';
import { ProcedureLinkDetailsViewModel } from './procedureLinkDetailsViewModel';

export interface ProcedureLinkDetailsViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<ProcedureLinkDetailsViewModel> | null;
  metaData?: PagedListMetaData;
}
